import { ActionType, createAction } from "typesafe-actions";

import PinLegendType from "@mapmycustomers/shared/enum/pinLegends/PinLegendType";
import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import PinLegend from "@mapmycustomers/shared/types/map/PinLegend";

export const showCreatePinLegendDrawer = createAction("pinSettingsUi/showCreateDrawer")<{
  entityType: EntityTypesSupportedByMapsPage;
  type: PinLegendType;
}>();

export const showPinSettings = createAction("pinSettingsUi/showPinSettings")<boolean>();

export const showUpdatePinLegendDrawer = createAction(
  "pinSettingsUi/showUpdateDrawer"
)<PinLegend>();

export const hidePinLegendDrawer = createAction("pinSettingsUi/hideDrawer")<void>();

export type PinSettingsUiActions = ActionType<
  | typeof hidePinLegendDrawer
  | typeof showCreatePinLegendDrawer
  | typeof showPinSettings
  | typeof showUpdatePinLegendDrawer
>;
